module.exports = __webpack_public_path__ + "img/云产品云桌面.f0724af4.jpg";